'use strict';

import versioner from '../versioner';
import process from './process';

versioner['loveland_water_distribution_after_hours'] = {
	process: process,
}

versioner['loveland_water_meter_after_hours'] = {
	process: process,
}

versioner['loveland_sewer_after_hours'] = {
	process: process,
}

const MODULE_NAME = 'daupler.incidents.versions.loveland';

export default MODULE_NAME;
